import { useWebsiteSettings, usePage } from 'publisher/store'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { typographySelectorMap } from 'src/publisher/store/website-settings/website-settings-selector'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateFontSize = ({
  fontSize,
  mobileFontSize,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontSize?: number
  mobileFontSize?: number
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalFontSize = usePage(pageSelectors.getGlobalTextFontSize)

  const typographySelector = typographySelectorMap[typographyType]
  const {
    fontSize: websiteGlobalFontSize,
    mobileFontSize: websiteGlobalMobileFontSize,
  } = useWebsiteSettings(typographySelector) || {}
  const pageGlobalMobileFontSize = usePage(
    pageSelectors.getGlobalMobileTextFontSize,
  )

  const globalFontSize = pageGlobalFontSize || websiteGlobalFontSize
  const globalMobileFontSize =
    pageGlobalMobileFontSize || websiteGlobalMobileFontSize

  return {
    calculatedFontSize: getCalculatedProperty({
      desktopProperty: fontSize,
      mobileProperty: mobileFontSize,
      globalDesktopProperty: globalFontSize,
      globalMobileProperty: globalMobileFontSize,
    }),
    globalFontSize: globalFontSize,
    globalMobileFontSize: globalMobileFontSize,
  }
}
